<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            Новый пользователь
                        </span>
                    </div>
                    <form @submit.prevent="saveUser">
                        <div class="panel-body p25">
                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Логин</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.user.login.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-user"></i></label>
                                    </label>
                                    <div v-if="$v.user.login.$error === true || forms.user.errors.login" class="error">
                                        {{ this.forms.user.errors.login ? this.forms.user.errors.login.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Пароль</label>
                                    <label class="field prepend-icon">
                                        <input type="password" v-model="$v.forms.user.password.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-key"></i></label>
                                    </label>
                                    <div v-if="$v.forms.user.password.$error === true || forms.user.errors.password" class="error">
                                        {{ this.forms.user.errors.password ? this.forms.user.errors.password.join(', ') : 'Введите верное значение (Не меньше 6 символов)' }}
                                    </div>
                                </div>
                            </div>
                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Имя</label>

                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.firstName.$model" type="text" class="gui-input">
                                        <label class="field-icon">
                                            <i class="fa fa-user"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.firstName.$error === true || forms.user.errors.name" class="error">
                                        {{ this.forms.user.errors.name ? this.forms.user.errors.name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <!-- end section -->

                                <div class="col-md-6">
                                    <label class="field-label">Фамилия</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.lastName.$model" type="text" class="gui-input">
                                        <label class="field-icon">
                                            <i class="fa fa-user"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.lastName.$error === true || forms.user.errors.last_name" class="error">
                                        {{ this.forms.user.errors.last_name ? this.forms.user.errors.last_name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <!-- end section -->
                            </div>
                            <!-- end section row section -->
                            <div class="section row">
                                <div class="col-md-6">

                                    <label class="field-label">Телефон</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.phone.$model" type="tel" class="gui-input"
                                               placeholder="+7925">
                                        <label class="field-icon">
                                            <i class="fa fa-phone-square"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.phone.$error === true || forms.user.errors.phone" class="error">
                                        {{ this.forms.user.errors.phone ? this.forms.user.errors.phone.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <!-- end section -->
                                <div class="col-md-6">
                                    <label class="field-label">Дата рождения</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.birthday.$model" type="date" class="gui-input">
                                        <label class="field-icon">
                                            <i class="fa  fa-calendar"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.birthday.$error === true || forms.user.errors.birthday" class="error">
                                        {{ this.forms.user.errors.birthday ? this.forms.user.errors.birthday.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Email</label>
                                    <label class="field prepend-icon">
                                        <input v-model="$v.user.email.$model" type="email" class="gui-input"
                                               placeholder="example@domain.com...">
                                        <label class="field-icon">
                                            <i class="fa fa-envelope"></i>
                                        </label>
                                    </label>
                                    <div v-if="$v.user.email.$error === true || forms.user.errors.email" class="error">
                                        {{ this.forms.user.errors.email ? this.forms.user.errors.email.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>
                            <div class="section row">
                                <div class="col-md-6">
                                    <label class="field-label">Роль</label>
                                    <label class="field select">
                                        <select v-model="user.role">
                                            <option
                                                    v-for="role in data.roles"
                                                    v-bind:key="role.role"
                                                    :value="role.role"
                                            >
                                                {{role.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.user.role.$error === true || forms.user.errors.role" class="error">
                                        {{ this.forms.user.errors.role ? this.forms.user.errors.role.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label class="field-label">Филиал</label>
                                    <label class="field select">
                                        <select v-model="user.filiationId">
                                            <option value="">Выберите филиал</option>
                                            <option
                                                    v-for="filiation in data.filiations"
                                                    v-bind:key="filiation.id"
                                                    :value="filiation.id"
                                            >
                                                {{filiation.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.user.filiationId.$error === true || forms.user.errors.filiation_id" class="error">
                                        {{ this.forms.user.errors.filiation_id ? this.forms.user.errors.filiation_id.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Должность</label>
                                    <label class="field select">
                                        <select v-model="user.postId">
                                            <option value="0">Нет</option>
                                            <option
                                                    v-for="post in data.posts"
                                                    v-bind:key="post.id"
                                                    :value="post.id"
                                            >
                                                {{post.name}}
                                            </option>
                                        </select>
                                        <i class="arrow double"></i>
                                    </label>
                                    <div v-if="$v.user.postId.$error === true || forms.user.errors.post_id" class="error">
                                        {{ this.forms.postId.errors.post_id ? this.forms.user.errors.post_id.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Комментарий</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.user.comment.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.user.isSubmitting">
                                Сохранить
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import User from "../../models/User";
    import Filiation from "../../models/Filliation";
    import { required, email, minLength } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';
    import UserPost from "../../models/UserPost";
    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {

            let filiationsResponse, userPostsResponse;
            [filiationsResponse, userPostsResponse] = await Promise.all([
                Filiation.getList(1, 999),
                UserPost.getList({}, 1, 'name', -1),
            ]);
            next(component => {
                component.data.filiations = filiationsResponse.data;
                component.data.posts = userPostsResponse.data;
            });
        },
        data() {
            return {
                data: {
                    filiations: [],
                    posts: [],
                    roles: [
                        {role: 'manager', name: 'Менеджер'},
                        {role: 'admin', name: 'Администратор'},
                    ],
                },
                user: new User({
                    status: User.STATUS_ACTIVE,
                    role: 'manager',
                    filiationId: '',
                    postId: 0,
                }),
                forms: {
                    user: {
                        isSubmitting: false,
                        errors: {},
                        password: '',
                    },
                },
            };
        },
        validations: {
            user: {
                postId: {},
                login: {required},
                firstName: {required},
                lastName: {},
                phone: {},
                birthday: {},
                email: {email},
                comment: {},
                status: {},
                role: {},
                filiationId: {},
            },
            forms: {
                user: {
                    password: {
                        required: required,
                        minLength: minLength(6),
                    },
                },
            },
        },
        methods: {

            async saveUser() {
                this.$v.forms.user.$touch();
                if (this.$v.forms.user.$invalid) {
                    return false;
                }

                this.forms.user.isSubmitting = true;
                this.forms.user.errors = {};

                try {
                    const user = await this.user.add(this.forms.user.password);

                    await this.$router.push({name: 'users-edit', params: {id: user.id}});
                } catch (error) {
                    this.forms.user.errors = error.errors;
                }


                this.forms.user.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Пользователи - добавление',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>